import { htmlSafe } from '@ember/template';
import { precompileTemplate } from '@ember/template-compilation';
import { setComponentTemplate } from '@ember/component';
import templateOnly from '@ember/component/template-only';

const classList = htmlSafe(`
  inline-block items-center grid-flow-col
  text-white rounded bg-[var(--code-bg)]
  px-3 py-2
  border border-[var(--horizon-border)]
  hover:underline
  focus:outline-none focus:ring
  focus-visible:outline-none focus-visible:ring
  shadow
  grid gap-2
`);
const Link = setComponentTemplate(precompileTemplate("\n  {{#if @isDisabled}}\n\n    <span class=\"{{classList}} opacity-30\" ...attributes tabindex=\"0\">\n      {{yield}}\n    </span>\n\n  {{else}}\n\n    {{!-- href attribute should be passed in to Link --}}\n    {{!-- The lints maybe need a runtime integration. --}}\n    {{!-- template-lint-disable link-href-attributes --}}\n    <a class={{classList}} ...attributes>\n      {{yield}}\n    </a>\n\n  {{/if}}\n", {
  strictMode: true,
  scope: () => ({
    classList
  })
}), templateOnly());

export { Link };
//# sourceMappingURL=link.js.map
